export default __webpack_public_path__ + "static/media/admin-list.4c433a92.svg";